import { Injectable, isDevMode } from '@angular/core';
import { RestService} from './rest.service';
import {ServiceDate} from "../model/service-date";
import { Observable, Subject } from 'rxjs';

@Injectable()
export class DateService {
  public dateSource = new Subject<ServiceDate>();
  public current_date: ServiceDate;
  public date$ = this.dateSource.asObservable();

  constructor(private restService: RestService) {}

  getDate(): Observable<Object> {
    return this.restService.get(`date`);
  }

  setDate(serviceDate: ServiceDate) {
    this.dateSource.next(serviceDate);
  }
}
